import type { ConversationCardData } from '../fragments/conversationCard'

/**
 * When the network stops letting us reply to a conversation, or `null` when
 * there is no window to speak of. Only a message conversation carries one;
 * other kinds that may join the inbox later are read as open until they say
 * otherwise.
 */
export function getReplyWindowExpiresAt(
  conversation: Pick<ConversationCardData, '__typename'> &
    Partial<Pick<ConversationCardData, 'replyWindow'>>,
): string | null {
  if (conversation.__typename !== 'MessageConversation') return null
  return conversation.replyWindow?.expiresAt ?? null
}

/**
 * Whether we can still reply through Buffer. The API carries no `canReply`
 * flag on purpose: the client compares the expiry to its own clock, so the
 * answer stays right while the thread is open without a refetch.
 */
export function isReplyWindowOpen(
  expiresAt: string | null,
  now: Date = new Date(),
): boolean {
  if (!expiresAt) return true
  return new Date(expiresAt) > now
}

/**
 * The counterpart's conversation in the Instagram app, for when the window
 * has closed and the reply has to happen there. `ig.me/m/<username>` is
 * Instagram's own deep link into a direct thread.
 */
export function instagramConversationUrl(username: string): string {
  return `https://ig.me/m/${encodeURIComponent(username)}`
}
